<template>
  <div class="vx-col w-full lg:w-1/4">
    <div class="vx-col w-full mt-base">
      <vx-card class="p-2">
        <vs-avatar class="mx-auto my-6 block" size="80px" :src="avatar" />
        <div class="text-center">
          <h5>{{ pengguna.nama }}</h5>
          <small class="text-grey">{{ pengguna.jabatan.nama }}</small>
        </div>
        <vs-button
          type="gradient"
          class="w-full mt-6"
          color="#7367F0"
          gradient-color-secondary="#CE9FFC"
          @click="$refs.dialogAvatar.toggleActive(true)"
          >Update Avatar
        </vs-button>
      </vx-card>
    </div>

    <vx-card title="Kredensial" class="mt-base">
      <div class="mt-5">
        <h6>Username :</h6>
        <p>{{ pengguna.login.username }}</p>
      </div>

      <vs-button
        type="gradient"
        class="w-full mt-6"
        color="#7367F0"
        gradient-color-secondary="#CE9FFC"
        @click="$refs.dialogKredensial.toggleActive(true)"
        >Update Kredensial
      </vs-button>
    </vx-card>
    <DialogKredensial
      ref="dialogKredensial"
      :pengguna="pengguna"
      @refreshPengguna="submitCallback"
    />
    <DialogAvatar
      ref="dialogAvatar"
      :penggunaId="pengguna.id"
      :dokumen="[]"
      @refreshPengguna="submitCallback"
    />
  </div>
</template>

<script>
import DialogKredensial from "./DialogKredensial";
import DialogAvatar from "./DialogAvatar";

export default {
  components: {
    DialogKredensial,
    DialogAvatar
  },
  props: {
    pengguna: {
      type: Object,
      required: true
    }
  },
  computed: {
    avatar() {
      if (this.$store.state.user.avatar !== null)
        return `${process.env.VUE_APP_DIGOF_URL}sources/${this.$store.state.user.avatar}`;
      else
        return "/images/avatar/default.jpg";
    }
  },
  methods: {
    submitCallback() {
      this.$emit('refreshPengguna');
    }
  }
};
</script>
